import React, { useEffect, useRef, useState } from 'react';
import { CheckboxSelectStyles as S } from './CheckboxSelectField.styles';
const CheckboxSelect = ({ filters, values, updateFilters, allowMulti = false, }) => {
    const selectRef = useRef(null);
    const [activeDropdown, setActiveDropdown] = useState(false);
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function handleClickOutside(event) {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setActiveDropdown(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [selectRef]);
    const dropdownTitle = !allowMulti && values?.length === 1
        ? `<strong>${filters.title}</strong>: ${filters.options.find((option) => option.value === values[0])?.text}`
        : filters.title;
    return (React.createElement(S.DropdownContainer, { "aria-current": activeDropdown, onClick: () => setActiveDropdown(!activeDropdown), ref: selectRef },
        React.createElement(S.ActiveDropdown, { dangerouslySetInnerHTML: { __html: dropdownTitle } }),
        React.createElement(S.Dropdown, { "aria-current": activeDropdown }, filters.options.map((option, index) => (React.createElement(S.DropdownItem, { key: `${option.id}-${index}`, "aria-current": values?.includes(option.value), "aria-multi": allowMulti, onClick: (e) => {
                updateFilters(filters.key, option.value, e);
                if (!allowMulti) {
                    setActiveDropdown(false);
                }
            } }, option.text))))));
};
export default CheckboxSelect;
